// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../reason/next/Next.bs.js");
let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Formality = require("../../vendor/re-formality/Formality.bs.js");
let Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
let Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
let ReactRender = require("../../reason/utils/ReactRender.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let IsNewQueryParam = require("./IsNewQueryParam.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RichTextEditorV5 = require("../common/Components/RichTextEditorV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let TeamMarketingProfileAboutSettingsQuery_graphql = require("../../__generated__/TeamMarketingProfileAboutSettingsQuery_graphql.bs.js");
let TeamMarketingProfileAboutSettingsMutation_graphql = require("../../__generated__/TeamMarketingProfileAboutSettingsMutation_graphql.bs.js");
let TeamMarketingProfileAboutSettings_form_teamMarketingProfile_graphql = require("../../__generated__/TeamMarketingProfileAboutSettings_form_teamMarketingProfile_graphql.bs.js");

let convertFragment = TeamMarketingProfileAboutSettings_form_teamMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileAboutSettings_form_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileAboutSettings_form_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, TeamMarketingProfileAboutSettings_form_teamMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileAboutSettings_form_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = TeamMarketingProfileAboutSettingsMutation_graphql.Internal.convertVariables;

let convertResponse = TeamMarketingProfileAboutSettingsMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = TeamMarketingProfileAboutSettingsMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, TeamMarketingProfileAboutSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, TeamMarketingProfileAboutSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

let validators = {
  about: undefined
};

function initialFieldsStatuses(input) {
  return {
    about: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    about: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      about: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, param, param$1) {
  let match = {
    TAG: "Ok",
    _0: input.about
  };
  if (match.TAG === "Ok") {
    return {
      TAG: "Valid",
      output: {
        about: match._0
      },
      fieldsStatuses: {
        about: {
          TAG: "Dirty",
          _0: match,
          _1: "Hidden"
        }
      },
      collectionsStatuses: undefined
    };
  } else {
    return {
      TAG: "Invalid",
      fieldsStatuses: {
        about: {
          TAG: "Dirty",
          _0: match,
          _1: "Hidden"
        }
      },
      collectionsStatuses: undefined
    };
  }
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurAboutField" :
          let result = Formality.validateFieldOnBlurWithoutValidator(state.input.about, state.fieldsStatuses.about, status => ({
            about: status
          }));
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Primitive_option.some(error._0);
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateAboutField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.about, status => ({
                about: status
              })),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  about: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  about: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: Primitive_option.some(map(Primitive_option.valFromOption(error$2)))
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateAbout: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateAboutField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurAbout: () => dispatch("BlurAboutField"),
    aboutResult: Formality.exposeFieldResult(state.fieldsStatuses.about),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.about;
      return typeof tmp === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let Config = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function initialInputFromFragment(fragment) {
  return {
    about: fragment.about
  };
}

function TeamMarketingProfileAboutSettings$Form$RichTextField(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: props.labelText
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(RichTextEditorV5.make, {
            initialContent: props.initialValue,
            onChange: props.onChange,
            onBlur: props.onBlur,
            toolbar: "withSingleHeadingLevel",
            proseStyle: "md"
          }),
          Stdlib_Option.getOr(Stdlib_Option.map(props.helpText, text => JsxRuntime.jsx("div", {
            children: text,
            className: "text-base text-gray-500"
          })), null)
        ],
        className: "mt-2 sm:col-span-2 sm:mt-0 space-y-3"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let RichTextField = {
  make: TeamMarketingProfileAboutSettings$Form$RichTextField
};

function TeamMarketingProfileAboutSettings$Form(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(TeamMarketingProfileAboutSettings_form_teamMarketingProfile_graphql.node, convertFragment, props.marketingProfile);
  let match = use$1();
  let mutate = match[0];
  let match$1 = IsNewQueryParam.use();
  let isNew = match$1[0];
  let router = Next.useRouter();
  let subpages = MarketingProfileSubpages.useTeamProfilePages(undefined, undefined);
  let nextPage = Stdlib_Option.flatMap(Stdlib_Array.findIndexOpt(subpages, param => param.page === "About"), i => subpages[i + 1 | 0]);
  let form = useForm(initialInputFromFragment(marketingProfile), (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    mutate({
      input: {
        about: param.about
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let result = param.updateTeamMarketingProfileAboutSection;
      if (result === undefined) {
        return notifyOnFailure();
      }
      if (result.__typename !== "TeamMarketingProfileAboutSectionUpdated") {
        return notifyOnFailure();
      }
      notifyOnSuccess(undefined);
      if (isNew && nextPage !== undefined) {
        return Next.Router.push(nextPage.path + `?is_new=1`, undefined, undefined, router);
      }
    }, param => notifyOnFailure(), undefined);
  });
  let match$2 = form.status;
  let tmp;
  if (typeof match$2 !== "object") {
    if (match$2 === "Editing") {
      tmp = null;
    } else {
      let __x = !isNew;
      tmp = ReactRender.ifTrue(JsxRuntime.jsx(Alert.Success.make, {
        title: "Your account was updated"
      }), __x);
    }
  } else {
    tmp = match$2.TAG === "Submitting" ? null : JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Alert.$$Error.make, {
          title: "There was an error updating your account. Please try again"
        }),
        className: "mt-4"
      });
  }
  return JsxRuntime.jsx("form", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(TeamMarketingProfileAboutSettings$Form$RichTextField, {
            onChange: value => form.updateAbout((_input, value) => ({
              about: value
            }), value),
            onBlur: param => form.blurAbout(),
            initialValue: marketingProfile.about,
            labelText: "About your team"
          }),
          className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              href: Scalars.URL.toString(marketingProfile.publicUrl),
              target: "_blank",
              children: "View Profile"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                  disabled: form.submitting,
                  children: isNew ? "Save and continue" : "Save changes"
                }),
                JsxRuntime.jsx("div", {
                  children: tmp,
                  role: "status"
                })
              ],
              className: "flex flex-col items-end gap-3"
            })
          ],
          className: "flex justify-between items-baseline"
        })
      ],
      className: "space-y-6"
    }),
    onSubmit: event => {
      event.preventDefault();
      form.submit();
    }
  });
}

let Form = {
  Fragment: Fragment,
  Mutation: Mutation,
  Config: Config,
  initialInputFromFragment: initialInputFromFragment,
  RichTextField: RichTextField,
  make: TeamMarketingProfileAboutSettings$Form
};

function TeamMarketingProfileAboutSettings$Header(props) {
  let displayName = MarketingProfileSubpages.Page.Team.useDisplayName();
  let breadcrumbs = [
    {
      name: "Team Marketing Profile",
      href: "/account/team_marketing_profile"
    },
    {
      name: displayName("About"),
      href: MarketingProfileSubpages.Page.Team.path("About")
    }
  ];
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsx(Breadcrumbs.make, {
        pages: breadcrumbs
      }),
      JsxRuntime.jsx("h2", {
        children: "About your team",
        className: "text-zinc-800 text-3xl font-medium"
      })
    ],
    className: "space-y-3 border-b pb-2"
  });
}

let Header = {
  make: TeamMarketingProfileAboutSettings$Header
};

let convertVariables$1 = TeamMarketingProfileAboutSettingsQuery_graphql.Internal.convertVariables;

let convertResponse$1 = TeamMarketingProfileAboutSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = TeamMarketingProfileAboutSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use$2 = RescriptRelay_Query.useQuery(convertVariables$1, TeamMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1);

let useLoader = RescriptRelay_Query.useLoader(convertVariables$1, TeamMarketingProfileAboutSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(TeamMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1, prim => prim);

let fetch = RescriptRelay_Query.fetch(TeamMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let fetchPromised = RescriptRelay_Query.fetchPromised(TeamMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let retain = RescriptRelay_Query.retain(TeamMarketingProfileAboutSettingsQuery_graphql.node, convertVariables$1);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$2,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function TeamMarketingProfileAboutSettings(props) {
  let match = use$2(undefined, undefined, undefined, undefined);
  let marketingProfile = match.currentAccountV5.marketingProfile;
  if (marketingProfile.__typename === "TeamMarketingProfile") {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(TeamMarketingProfileAboutSettings$Header, {}),
          JsxRuntime.jsx(TeamMarketingProfileAboutSettings$Form, {
            marketingProfile: marketingProfile.fragmentRefs
          })
        ],
        className: "space-y-8 sm:space-y-0"
      }),
      className: "bg-white p-6 shadow-sm rounded space-y-8"
    });
  } else {
    return UnselectedUnionMemberError.raise(`Unselected union member: ` + marketingProfile._0);
  }
}

let make = TeamMarketingProfileAboutSettings;

exports.Form = Form;
exports.Header = Header;
exports.Query = Query;
exports.make = make;
/* commitMutation Not a pure module */
